// extracted by mini-css-extract-plugin
module.exports = {"copyright":"footer_copyright__3Ehe7"};